module.exports = __webpack_public_path__ + "img/sug5.51cc5cca.png";